import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const IncidentDescription = ({ incident, onUpdate, canEdit }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [description, setDescription] = useState(incident?.description);

  const handleSave = () => {
    onUpdate({ ...incident, description });
    setIsEditing(false);
  };

  const handleCancel = () => {
    setDescription(incident?.description);
    setIsEditing(false);
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-foreground flex items-center gap-2">
          <Icon name="FileText" size={20} />
          Incident Description
        </h2>
        {canEdit && !isEditing && (
          <Button
            variant="ghost"
            size="sm"
            iconName="Edit"
            onClick={() => setIsEditing(true)}
          >
            Edit
          </Button>
        )}
      </div>
      {isEditing ? (
        <div className="space-y-4">
          <textarea
            value={description}
            onChange={(e) => setDescription(e?.target?.value)}
            className="w-full h-40 p-3 border border-border rounded-md resize-none focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
            placeholder="Enter incident description..."
          />
          <div className="flex gap-2">
            <Button
              variant="default"
              size="sm"
              iconName="Check"
              onClick={handleSave}
            >
              Save
            </Button>
            <Button
              variant="outline"
              size="sm"
              iconName="X"
              onClick={handleCancel}
            >
              Cancel
            </Button>
          </div>
        </div>
      ) : (
        <div className="prose max-w-none">
          <p className="text-foreground whitespace-pre-wrap leading-relaxed">
            {incident?.description}
          </p>
        </div>
      )}
      {/* Additional Details */}
      <div className="mt-6 pt-6 border-t border-border">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <h3 className="text-sm font-medium text-foreground mb-2">Detection Method</h3>
            <p className="text-sm text-muted-foreground">{incident?.detectionMethod}</p>
          </div>
          <div>
            <h3 className="text-sm font-medium text-foreground mb-2">Source</h3>
            <p className="text-sm text-muted-foreground">{incident?.source}</p>
          </div>
          <div>
            <h3 className="text-sm font-medium text-foreground mb-2">Category</h3>
            <p className="text-sm text-muted-foreground">{incident?.category}</p>
          </div>
          <div>
            <h3 className="text-sm font-medium text-foreground mb-2">Subcategory</h3>
            <p className="text-sm text-muted-foreground">{incident?.subcategory}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IncidentDescription;